import * as React from 'react';
import { DEFAULT_HOTEL_BASKET, HotelBasketContext } from './HotelBasketContext';
import { hotelBasketReducer } from './HotelBasketReducer';
export function HotelBasketProvider({ children, estabId, defaultContext }) {
    const [hotelBasket, dispatch] = React.useReducer(hotelBasketReducer, Object.assign(Object.assign({}, (defaultContext !== null && defaultContext !== void 0 ? defaultContext : DEFAULT_HOTEL_BASKET)), { estabId }));
    const contextValue = React.useMemo(() => ({ hotelBasket, dispatch }), [hotelBasket, dispatch]);
    return React.createElement(HotelBasketContext.Provider, { value: contextValue }, children);
}
